var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.needCookieBanner)?_c('CBanner',{ref:"banner",attrs:{"on-accept":_vm.onAccept,"get-cookie-consents":_vm.getCookieConsents,"on-show":_vm.onShow,"lang":_vm.langType}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }